import SelectMenu from "../controls/SelectMenu";

export default function FilterSingleSelectDropdown(props) {
  const { header, onChange, options, resetFilter, valueName, value } = props;

  return (
    <div className="p-4">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-semibold text-[#0F172A]">{header}</p>
        <button
          type="button"
          onClick={() => resetFilter()}
          className="text-xs font-semibold text-[#2563EB] hover:text-[#1D4ED8]"
        >
          Reset
        </button>
      </div>
      <div className="mt-2 min-w-0 w-full max-w-full">
        <SelectMenu
          handleInputChange={(e) => {
            onChange(e.target.value);
          }}
          menuPortalTarget={
            typeof document !== "undefined" ? document.body : null
          }
          name={valueName}
          options={options}
          value={value}
          filter={options.length > 8}
          isClearable
        />
      </div>
    </div>
  );
}
